import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { IMaskInput } from "react-imask";

export default function MaskedPhoneNumberInput({
  name,
  describedby,
  register,
  setValue,
  defaultValue,
  disabled,
  required = true,
}) {
  const { t } = useTranslation();
  const ref = useRef(null);

  return (
    <IMaskInput
      ref={ref}
      mask={"(000) 000-0000"}
      defaultValue={defaultValue}
      disabled={disabled}
      placeholder="(XXX) XXX-XXXX"
      unmask={false}
      lazy={true}
      placeholderChar="X"
      // DO NOT USE onChange TO HANDLE CHANGES!
      // USE onAccept INSTEAD
      onAccept={
        // depending on prop above first argument is
        // `value` if `unmask=false`,
        // `unmaskedValue` if `unmask=true`,
        // `typedValue` if `unmask='typed'`
        (value, mask) => {
          setValue(name, value);
        }
      }
      {...register(
        name,
        required
          ? {
              required: t("MaskedPhoneNumber-input-required"),
              validate: {
                length: (value) =>
                  value
                    ? value.replace(/[^\d]/g, "")?.length < 10
                      ? t("MaskedPhoneNumber-input-validate")
                      : null
                    : t("MaskedPhoneNumber-input-required"),
              },
            }
          : {
              validate: {
                length: (value) =>
                  value
                    ? value.replace(/[^\d]/g, "")?.length < 10
                      ? t("MaskedPhoneNumber-input-validate")
                      : null
                    : null,
              },
            }
      )}
      aria-describedby={describedby}
    />
  );
}
